export default __webpack_public_path__ + "static/media/water.de76bf0d.svg";